import React from 'react'
import Link from 'next/link'
import { useSession } from 'next-auth/react'

import { useAppSelector } from '#/app/store/store'
import { getDeviceType } from '#/shared/lib/helpers'
import { bindYandexMetrikaUserId, initYandexMetrika, stopYandexMetrika } from '#/shared/lib/yandex-metrika'

import styles from './cookie-consent.module.scss'

function getConsent(): string | null {
	if (typeof window === 'undefined') return null
	const value = localStorage.getItem('cookie-consent')
	if (value === 'all' || value === 'necessary' || value === 'declined') return value
	return null
}

export function CookieConsent() {
	const { status } = useSession()
	const meStatus = useAppSelector((state) => state.user.status)
	const uid = useAppSelector((state) => state.user.uid)
	const [consent, setConsent] = React.useState<string | null | undefined>(undefined)
	const desktop = getDeviceType() === 'desktop'

	React.useEffect(() => {
		if (meStatus !== 'succeeded') return
		const stored = getConsent()
		setConsent(stored)
		if (stored === 'all') {
			initYandexMetrika()
			if (uid) bindYandexMetrikaUserId(uid)
		}
	}, [meStatus, uid])

	const choose = (value: string) => {
		localStorage.setItem('cookie-consent', value)
		setConsent(value)
		if (value === 'all') {
			initYandexMetrika()
			if (uid) bindYandexMetrikaUserId(uid)
		}
	}

	if (status !== 'authenticated' || meStatus !== 'succeeded') return null
	if (consent !== null) return null

	return (
		<div className={`${styles.banner} ${desktop ? styles.desktop : styles.mobile}`}>
			<div className={styles.content}>
				<h2 className={styles.title}>Cookies и аналитика</h2>
				<p className={styles.text}>
					Мы используем технические cookies для работы сайта и аналитические cookies для улучшения сервиса. Подробнее — в{' '}
					<Link href='https://air.fail/personal' className={styles.link} target='_blank'>
						Политике обработки персональных данных
					</Link>
					.
				</p>
			</div>
			<div className={styles.actions}>
				<div className={styles.row}>
					<button type='button' className={styles.btnPrimary} onClick={() => choose('all')}>
						Принять все
					</button>
					<button type='button' className={styles.btnPrimary} onClick={() => choose('necessary')}>
						Принять необходимые
					</button>
				</div>
				<button type='button' className={styles.btnOutline} onClick={() => choose('declined')}>
					Отклонить
				</button>
			</div>
		</div>
	)
}
